import React from "react";
import "./registration-table-wealth.css";
function RegistartionTableWealth() {
  return (
    <>
      <div class="search-container">
        <div className="content-title">
          <h>Investor</h>
        </div>
        <div className="search-container-wrapper">
          <div className="search-filter-container">
            <div class="search-wrapper">
              <input
                type="text"
                id="search-input"
                class="search-input"
                placeholder="Search by Unique ID/name"
              />
              <button id="search-button" class="search-button">
                Search
              </button>
            </div>
            <div class="filter-wrapper">
              <label for="kyc-status" class="filter-label">
                OR search by KYC Status
              </label>
              <select id="kyc-status" class="filter-select">
                <option value="all">All</option>
                <option value="pending">Pending</option>
                <option value="completed">Completed</option>
                <option value="under-review">Under Review</option>
              </select>
            </div>
          </div>

          <div className="download-button-container">
            <button id="download-button" class="download-button">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="download-icon"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="7 10 12 15 17 10"></polyline>
                <line x1="12" y1="15" x2="12" y2="3"></line>
              </svg>
              Download
            </button>
          </div>
        </div>
        <div class="entries-wrapper">
          <label for="entries-select" class="entries-label">
            Show
          </label>
          <select id="entries-select" class="entries-select">
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
          </select>
          <span class="entries-label">Entries</span>
        </div>
      </div>
      <div class="table-container">
        <table class="registration-table">
          <thead>
            <tr>
              <th>IRA Code</th>
              <th>Wealth Partner Name</th>
              <th>KYC Status</th>
              <th>Registration Date</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td data-label="IRA Code">IRI73087645956</td>
              <td data-label="Wealth Partner Name">CHETAN DILIP GHARMALKAR</td>
              <td data-label="KYC Status">
                <span class="status-badge status-pending">Pending</span>
              </td>
              <td data-label="Registration Date">06-11-2024</td>
              <td data-label="Action">
                <button class="action-button" aria-label="View details">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="action-icon"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </td>
            </tr>
            <tr>
              <td data-label="IRA Code">IRI73087645956</td>
              <td data-label="Wealth Partner Name">
                KARVY CAPITAL ARBITRAGE OPPORTUNITIES FUND
              </td>
              <td data-label="KYC Status">
                <span class="status-badge status-completed">Completed</span>
              </td>
              <td data-label="Registration Date">06-11-2024</td>
              <td data-label="Action">
                <button class="action-button" aria-label="View details">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    class="action-icon"
                  >
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                    <circle cx="12" cy="12" r="3"></circle>
                  </svg>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="pagination">
          <button class="pagination-button" disabled>
            Previous
          </button>
          <span class="pagination-info">Page 1 of 10</span>
          <button class="pagination-button">Next</button>
        </div>
      </div>
    </>
  );
}

export default RegistartionTableWealth;
